import React from 'react';
import QuestionManager from '../components/QuestionManager';

const AdminBrokerQuestions = () => {
  return (
    <QuestionManager 
      category="broker" 
      title="Manage Broker Questions"
      description="Configure questions for broker verification"
    />
  );
};

export default AdminBrokerQuestions;
